import { MappedResult } from '../mapped/index.mjs';
import { Readonly } from './readonly.mjs';
// prettier-ignore
function FromProperties(K, F) {
    return globalThis.Object.getOwnPropertyNames(K).reduce((Acc, K2) => {
        return { ...Acc, [K2]: Readonly(K[K2], F) };
    }, {});
}
// prettier-ignore
function FromMappedResult(R, F) {
    return FromProperties(R.properties, F);
}
// prettier-ignore
export function ReadonlyFromMappedResult(R, F) {
    const P = FromMappedResult(R, F);
    return MappedResult(P);
}
